// extracted by mini-css-extract-plugin
export default {"page":"RemovalPage_page__58sx8"};